import { AppRouteProps } from "@harea/component";
import React from "react";

const AuthorityListContainer = React.lazy(
    () => import("./containers/AuthorityListContainer"),
);
const AuthorityFormContainer = React.lazy(
    () => import("./containers/AuthorityFormContainer"),
);

export const AuthorityRoutes: Array<AppRouteProps> = [
    {
        path: "authority",
        title: "Bo.Authority.List.Title",
        element: <AuthorityListContainer />,
        children: [
            {
                path: "create",
                title: "Bo.Authority.Create.Title",
                element: <AuthorityFormContainer />,
            },
            {
                path: ":id/edit",
                title: "Bo.Authority.Edit.Title",
                element: <AuthorityFormContainer />,
            },
        ],
    },
];
